<template lang="pug">
  iframe( src='https://idx.mlspin.com/viewlistings.asp?aid=CN209320' frameborder="0" )
</template>

<script>
export default {
  metaInfo: {
    title: 'Sales | Upright Realty',
    meta: [
      { name: 'description', content: 'Buy or sell property with experienced agents that know the Massachusetts markets.' }
    ]
  },
}
</script>

<style lang="scss" scoped>

iframe{
  width: 100%;
  height: 100%;
  min-height: 600px;
  text-align: center;
  margin: auto;
}

</style>
